import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import DataTableLayer from '../../components/DataTableLayer'

const HistoryModal = ({ open, handleClose, data }) => {
  if (!open) return null;

  // definisi kolom
  const historyColumns = [
    {
        header:"Document Code",
        accessorKey:"document_code"
    },
    {
        header:"Document History Code",
        accessorKey:"document_history_code"
    },
    {
      header: "Description",
      accessorKey: "description"
    },
    {
      header: "Status",
      accessorKey: "status_name",
      cell: ({ row }) => {
        const status = row.getValue("status_name") || "-";
        let badgeColor;
        switch (status.toUpperCase()) {
          case "DRAFT":
            badgeColor = "bg-danger";
            break;
          case "SENT":
            badgeColor = "bg-primary";
            break;
          case "RECEIVED":
            badgeColor = "bg-info";
            break;
          case "RETURNED":
          case "RESENT":
            badgeColor = "bg-warning";
            break;
          case "APPROVED":
            badgeColor = "bg-success";
            break;
          case "REJECTED":
            badgeColor = "bg-secondary";
            break;
          default:
            badgeColor = "bg-light";
        }
        return <span className={`badge ${badgeColor}`}>{status}</span>;
      }
    },
    {
      header: "Created By",
      accessorKey: "created_by"
    },
    {
      header: "Created At",
      accessorKey: "created_at"
    },
    {
      header: "Preview",
      accessorKey: "document_url",
      cell: ({ row }) => {
        const url = row.getValue("document_url");
        return url && url !== "-" ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-outline-primary"
          >
            <Icon icon="mdi:eye" width={20} height={20} className="me-2" />
            View
          </a>
        ) : (
          "-"
        );
      }
    }
  ];

  return (
    <div className="modal show fade d-block" tabIndex="-1">
      <div className="modal-dialog modal-xl">
        <div className="modal-content shadow-lg border-0 rounded-4">
          <div className="modal-header bg-primary text-white rounded-top-4">
            <h5 className="modal-title">📜 Document History</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            <DataTableLayer
              data={data}
              columns={historyColumns}
              title="Riwayat Dokumen"
              showButton={false}
              pagination={{
                pageIndex: 0,
                pageSize: data.length,
                totalRecords: data.length,
                totalPages: 1
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryModal;
